import { Pane } from "src/components/Pane";
import { UploadCaseShapeForm, type CaseShapeFormData } from "src/forms/UploadCaseShapeForm";
import { useCaseShapeUploadMutation } from "src/hooks";
import type { Feature, Polygon, MultiPolygon } from "geojson";
import { styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  onPrevious: () => void;
  onNext: (data: Feature<Polygon | MultiPolygon>, warningList: string[]) => void;
}

export function CaseUploadShape(props: Props) {
  const { onNext, onPrevious } = props;
  const { t } = useTranslation();
  const { mutateAsync: uploadCaseShape, isLoading: isUploading, error: uploadError } = useCaseShapeUploadMutation();

  async function handleUploadCaseShape(data: CaseShapeFormData) {
    if (!data.caseShapefile) return;
    await uploadCaseShape(data, {
      onSuccess: (data) => {
        const polygonFeature: Feature<Polygon | MultiPolygon> = {
          type: "Feature",
          geometry: data.polygon_4326,
          properties: {},
        };
        onNext(polygonFeature, data.warningList);
      },
    });
  }
  return (
    <Styles>
      <Typography variant="h4" color="primary">
        {t("title.createCase")}
      </Typography>
      <Typography variant="body1">{t("label.uploadZIPWithShapefile")}</Typography>
      <ul>
        <li>{t("label.includesShapefileFiles")}</li>
        <li>{t("label.containsSinglePolygonDefiningCaseArea")}</li>
        <li>{t("label.hasNoPointsOrLines")}</li>
        <li>{t("label.isInEPSG4326CoordinateSystem")}</li>
      </ul>
      <UploadCaseShapeForm
        data={{ caseShapefile: null }}
        onPrevious={onPrevious}
        isLoading={isUploading}
        errors={uploadError?.response?.data}
        statusBody={null}
        onSubmit={handleUploadCaseShape}
        resetErrorsOnChange={true}
      />{" "}
    </Styles>
  );
}

const Styles = styled(Pane)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  ul {
    padding-inline-start: ${({ theme }) => theme.spacing(3)};
    margin-block-start: 0;
    margin-block-end: 0;
  }
`;
